import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Loading } from 'secondstep-components'

import { operations as userContextOperations } from 'auth/stores/userContext'
import NavigationHelper from 'layers/navigation/navigationHelper'
import withApiError from 'layers/errorHandling/apiError'
import withSiteContext from 'layers/content/v2/Hocs/withSiteContext'
import { operations as licenseOperations } from 'store/licenseManager'
import {
  operations as lmsOperations,
  selectors as lmsSelectors,
} from 'store/lmsManager'
import { operations as siteOperations } from 'store/siteManager'
import { userSegmentationBuilder } from 'utils/userSegmentationHelpers'
import { resolveRouteServiceApp } from 'utils/routing/routeHelpers'
import {
  K8_TRAINING_SETUP_LOADING_TEXT,
  useK8TrainingAutoSetup,
} from 'utils/program/training/autoSetup'

import { FlaggedRouteContentGetter as RouteContentGetter } from 'layers/content/v2/Hocs/FlaggedRouteContentGetter'

import Component from './component'

export const PagesV2Container = props => {
  const {
    createCourseInstanceByCourse,
    currentSite,
    fetchUserContext,
    fetchUserSites,
    k8InstructorData,
    location,
    updateSiteUserPreferences,
  } = props

  const isAutoSetupPending = useK8TrainingAutoSetup({
    createCourseInstanceByCourse,
    currentSite,
    fetchUserContext,
    fetchUserSites,
    k8InstructorData,
    pathname: location?.pathname,
    updateSiteUserPreferences,
  })

  if (isAutoSetupPending) {
    return <Loading loadingText={K8_TRAINING_SETUP_LOADING_TEXT} />
  }

  return <Component {...props} />
}

PagesV2Container.propTypes = {
  createCourseInstanceByCourse: PropTypes.func,
  currentSite: PropTypes.object,
  fetchUserContext: PropTypes.func,
  fetchUserSites: PropTypes.func,
  k8InstructorData: PropTypes.object,
  location: PropTypes.object,
  updateSiteUserPreferences: PropTypes.func,
}

const mapStateToProps = state => {
  const { productManager } = state

  return {
    k8InstructorData: {
      K5SelDigital: lmsSelectors.selectk5InstructorData(state),
      MspDigital: lmsSelectors.selectMiddleSchoolInstructorData(state),
    },
    userSegmentationInfo: userSegmentationBuilder(state),
    productTabTitle: productManager?.productMap?.name || '',
  }
}

const mapDispatchToProps = {
  createCourseInstanceByCourse: lmsOperations.createCourseInstanceByCourse,
  fetchUserContext: userContextOperations.fetchUserContextReduxConnect,
  fetchUserSites: licenseOperations.fetchUserSites,
  updateSiteUserPreferences: siteOperations.updateSiteUserPreferences,
}

const navigationConnect = connect(
  NavigationHelper.mapStateToProps,
  NavigationHelper.mapDispatchToProps,
)
const stateConnect = connect(mapStateToProps, mapDispatchToProps)

const options = {
  app: ({ route }) => resolveRouteServiceApp(route),
  routeResolver: () => window?.location?.pathname,
}

const ConnectedPagesV2Container = RouteContentGetter(
  withApiError(stateConnect(navigationConnect(PagesV2Container))),
  options,
)

export const PagesV2WithSiteContext = withSiteContext(ConnectedPagesV2Container)

export default ConnectedPagesV2Container
